import sweetAlertService from 'utils/sweetAlertService';
import commonService from 'utils/commonService';
import apiService from './apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { Captcha, MemberLoginReq, MemberLoginRes, Secque, VerifySecqueReq } from 'bff/models/login';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { Codes } from 'bff/models/info';
import { Login } from 'constants/models/components/login';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const fetchInitSetting = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchCaptcha(baseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([captchaRes, UICodeRes]) => {
    const captchaBaseRes: BaseRes<Captcha> = { ...captchaRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };

    const res: Login = {
      captcha: { ...captchaBaseRes.TRANRS },
      UICode: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES)
    };
    return res;
  });
  return result;
};

/**
 * @description 取得驗證碼方法
 */
const fetchCaptcha = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const result: BaseRes<Captcha> = await apiService.fetchCaptcha(baseReq, reqConfig).then((res: BaseRes<Captcha>) => res);

  if (result.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    sweetAlertService.info('無法取得驗證碼');
  } else {
    return { ...result.TRANRS };
  }
};

/**
 * @description 會員登入 Page 1 進行登入檢核方法
 * @param memberLoginReq 登入檢核 Request Model
 */
const memberLogin = async (memberLoginReq: MemberLoginReq) => {
  const baseReq = commonService.getApiReqData(memberLoginReq);
  const reqConfig = commonService.getReqConfig();
  const result = await apiService.memberLogin(baseReq, reqConfig).then((res: BaseRes<MemberLoginRes>) => res);

  if (result.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    return result.MWHEADER.RETURNDESC;
  }

  return result;
};

/**
 * @description 會員登入 詢問安全問題頁 取得會員安全問題
 * @param memberId 會員登入帳號 (身份證號)
 */
const fetchMemberSecque = async (memberId: string) => {
  const reqConfig = commonService.getReqConfig();
  const fetchMemberSecqueReq = commonService.getApiReqData({ MEMBER_ID: memberId });

  const result = await apiService.fetchMemberSecque(fetchMemberSecqueReq, reqConfig).then((res: BaseRes<Secque>) => res);
  if (result.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    sweetAlertService.error('無法取得安全問題');
  } else {
    return { ...result.TRANRS };
  }
};

/**
 * @description 會員登入 驗證安全問題查核
 * @param validSecqueReq 會員驗證問題查核 Request Model
 * @param memberId 會員登入帳號 (身份證號)
 */
const verifySecque = async (validSecqueReq: VerifySecqueReq) => {
  const baseReq = commonService.getApiReqData(validSecqueReq);
  const reqConfig = commonService.getReqConfig();
  const result = await apiService.verifySecque(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (result.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      title: '安全問題答案錯誤',
      html: 'hi~您的答案錯誤，請重新輸入，或於上班日周一至週五08:30-17:30來電洽0800-024-024取得其他登入方式，謝謝您。'
    });
  } else {
    return result.TRANRS;
  }
};

/**
 * @description 會員解鎖驗證
 * @param uuid 解鎖辨識用 UUID
*/
const statusUnlock = async (uuid: string) => {
  const baseReq = commonService.getApiReqData({ UNLOCK_UUID: uuid });
  const reqConfig = commonService.getReqConfig();

  return await apiService.statusUnlock(baseReq, reqConfig).then((res: BaseRes<any>) => res);
};

export default {
  fetchInitSetting,
  fetchCaptcha,
  memberLogin,
  fetchMemberSecque,
  verifySecque,
  statusUnlock
};
